import '../assets/NcTextArea.css';
import { defineComponent, useModel, useAttrs, useTemplateRef, computed, watch, openBlock, createElementBlock, normalizeClass, unref, createElementVNode, mergeProps, toDisplayString, createCommentVNode, createBlock, createTextVNode, mergeModels } from "vue";
import { d as mdiCheck, j as mdiAlertCircleOutline } from "./mdi.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper.mjs";
import { c as createElementId } from "./createElementId.mjs";
import { a as isLegacy } from "./legacy.mjs";
import { l as logger } from "./logger.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper.mjs";
const _hoisted_1 = { class: "textarea__main-wrapper" };
const _hoisted_2 = ["id", "aria-describedby", "disabled", "placeholder", "value"];
const _hoisted_3 = ["for"];
const _hoisted_4 = ["id"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ inheritAttrs: false },
  __name: "NcTextArea",
  props: /* @__PURE__ */ mergeModels({
    disabled: { type: Boolean },
    error: { type: Boolean },
    helperText: { default: void 0 },
    id: { default: () => createElementId() },
    inputClass: { default: "" },
    label: { default: void 0 },
    labelOutside: { type: Boolean },
    placeholder: { default: void 0 },
    resize: { default: "both" },
    success: { type: Boolean }
  }, {
    "modelValue": { required: true },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const modelValue = useModel(__props, "modelValue");
    const props = __props;
    __expose({
      focus,
      select
    });
    const attrs = useAttrs();
    const textAreaElement = useTemplateRef("input");
    const internalPlaceholder = computed(() => props.placeholder || (isLegacy ? props.label : void 0));
    watch(() => props.labelOutside, () => {
      if (!props.labelOutside && !props.label) {
        logger.warn("[NcTextArea] You need to add a label to the NcInputField component. Either use the prop label or use an external one, as per the example in the documentation.");
      }
    });
    const ariaDescribedby = computed(() => {
      const ariaDescribedby2 = [];
      if (props.helperText) {
        ariaDescribedby2.push(`${props.id}-helper-text`);
      }
      if (typeof attrs["aria-describedby"] === "string") {
        ariaDescribedby2.push(attrs["aria-describedby"]);
      }
      return ariaDescribedby2.join(" ") || void 0;
    });
    function handleInput(event) {
      const { value } = event.target;
      modelValue.value = value;
    }
    function focus(options) {
      textAreaElement.value.focus(options);
    }
    function select() {
      textAreaElement.value.select();
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["textarea", [
          _ctx.$attrs.class,
          {
            "textarea--disabled": __props.disabled,
            "textarea--legacy": unref(isLegacy)
          }
        ]])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("textarea", mergeProps({ ..._ctx.$attrs, class: void 0 }, {
            id: __props.id,
            ref: "input",
            "aria-describedby": ariaDescribedby.value,
            "aria-live": "polite",
            class: ["textarea__input", [
              __props.inputClass,
              {
                "textarea__input--label-outside": __props.labelOutside,
                "textarea__input--legacy": unref(isLegacy),
                "textarea__input--success": __props.success,
                "textarea__input--error": __props.error
              }
            ]],
            disabled: __props.disabled,
            placeholder: internalPlaceholder.value,
            style: { resize: __props.resize },
            value: modelValue.value,
            onInput: handleInput
          }), null, 16, _hoisted_2),
          !__props.labelOutside ? (openBlock(), createElementBlock("label", {
            key: 0,
            class: "textarea__label",
            for: __props.id
          }, toDisplayString(__props.label), 9, _hoisted_3)) : createCommentVNode("", true)
        ]),
        __props.helperText ? (openBlock(), createElementBlock("p", {
          key: 0,
          id: `${__props.id}-helper-text`,
          class: normalizeClass(["textarea__helper-text-message", {
            "textarea__helper-text-message--error": __props.error,
            "textarea__helper-text-message--success": __props.success
          }])
        }, [
          __props.success ? (openBlock(), createBlock(NcIconSvgWrapper, {
            key: 0,
            class: "textarea__helper-text-message__icon",
            path: unref(mdiCheck),
            inline: ""
          }, null, 8, ["path"])) : __props.error ? (openBlock(), createBlock(NcIconSvgWrapper, {
            key: 1,
            class: "textarea__helper-text-message__icon",
            path: unref(mdiAlertCircleOutline),
            inline: ""
          }, null, 8, ["path"])) : createCommentVNode("", true),
          createTextVNode(" " + toDisplayString(__props.helperText), 1)
        ], 10, _hoisted_4)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const NcTextArea = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-d327fb49"]]);
export {
  NcTextArea as N
};
//# sourceMappingURL=NcTextArea.mjs.map
